 
import React from 'react';

const UserProfile = () => (
  <div>
    <h1>User Profile</h1>
    <p>View and update your user information here.</p>
  </div>
);

export default UserProfile;
